const messages = {
  title: "Informations produits ET homologations",
  description:
    "Bienvenue dans la zone brochures et listes de prix des produits Bridgestone et Firestone. Vous trouverez ici les brochures et listes de prix actuelles pour tous les segments ainsi que les fichiers Pricat pour vos systèmes de gestion.",
  productInfo: {
    categories: {
      info: "Infos sur le produit",
      priceList: "Listes de prix",
      contact: "Contact",
    },
    page: {
      description:
        "Bienvenue dans l’espace d’informations autour des produits Bridgestone & Firestone.<br/>Vous trouverez ici des brochures et listes de prix actuelles ainsi que des liens utiles et des formulaires.",
    },
    index: {
      title: "Informations sur les produits",
      description:
        "Bienvenue dans l’espace d’informations autour des produits Bridgestone et Firestone.<br/>Vous trouverez ici des brochures actuelles et du matériel complémentaire.",
      categories: {
        productBrochures: {
          title: "Brochures produits",
          description:
            "Brochures produits Bridgestone et Firestone actuelles à télécharger",
        },
        bDrive: {
          title: "Images de pneus &<br/>logos",
          description: "Logos, images produits et modèles marketing actuels",
          button: "VERS B-DRIVE",
        },
        calculator: {
          title:
            "Calculateur d’économie<br/><span class='text-danger'>de carburant</span>",
          description:
            "Pneus à résistance au roulement optimisée – calculez facilement les potentiels d’économie !",
        },
        carApprovals: {
          title: "Homologations voitures Bridgestone",
          description:
            "Trouvez les pneus Bridgestone adaptés et homologués pour votre véhicule",
        },
        carApprovalsFS: {
          title: "Homologations voitures Firestone",
          description:
            "Trouvez les pneus Firestone adaptés et homologés pour votre véhicule",
        },
        motApprovals: {
          title: "Homologations moto",
          description:
            "Trouvez les pneus moto Bridgestone adaptés et homologés",
        },
        dataGenereate: {
          title: "Générateur de fiches techniques",
          description:
            "Saisissez l’IPC et générez votre propre fiche technique",
        },
      },
    },
  },
  priceDescription:
    "Téléchargez les listes de prix actuelles pour votre usage.",
  pricatDescription:
    "Vous trouverez ici des fichiers Pricat pour votre système de gestion commerciale.",
  pricat: {
    title: "Pricat",
    description:
      "Téléchargez ici des fichiers CSV et TEXT pour vos systèmes ERP, informatiques & autres.",
  },
  pkw: {
    title: "Listes de prix des pneus pour voitures, 4x4 et camionnettes",
    description:
      "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone",
  },
  trucksAndBuses: {
    title: "Listes de prix camions et bus",
    description:
      "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul> <li>Camions et bus</li> </ul>",
  },
  motorcycles: {
    title: "Listes de prix pneus moto",
    description:
      "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone : <ul> <li>Moto</li> </ul>",
  },
  agriculture: {
    title: "Listes de prix pneus agricoles",
    description:
      "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul> <li>Agriculture</li> </ul>",
  },
  constructionMachineryOtr: {
    title: "Listes de prix pneus pour machines de chantier/OTR",
    description:
      "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul><li>Machines de chantier/OTR</li></ul>",
  },
  main: {
    title: "Listes de prix",
    description:
      "Téléchargez ici les listes de prix actuelles de nos pneus Bridgestone et Firestone : <ul><li>Voitures de tourisme, 4x4 et camionnettes</li><li>Moto</li><li>Camions et bus</li> <li>Agriculture</li><li>Machines de chantier / OTR</li></ul>",
  },
  index: {
    description:
      "Bienvenue dans la zone d'informations sur les produits Bridgestone et Firestone. Vous trouverez ici les brochures actuelles, les tarifs et les dossiers Pricat.",
  },
};
export default {
  messages,
};
